<router-outlet>
  <app-loader [loader]="loader"></app-loader>
</router-outlet>
